export default __webpack_public_path__ + "assets/images/231cade4b3d0adaec9df127f6f93277c.svg";